import { render, staticRenderFns } from "./mark-mobile.vue?vue&type=template&id=6bb77fda&scoped=true"
import script from "./mark-mobile.vue?vue&type=script&lang=ts"
export * from "./mark-mobile.vue?vue&type=script&lang=ts"
import style0 from "./mark-mobile.vue?vue&type=style&index=0&id=6bb77fda&prod&lang=scss"
import style1 from "./mark-mobile.vue?vue&type=style&index=1&id=6bb77fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb77fda",
  null
  
)

export default component.exports